import {Observable} from 'rxjs';
import {palipaliAPI} from '../provider/palipaliAPI';
import {IApiSingleResponseBase} from '../../types';
import {RestQueryParams} from '../base/queryParams';
import {ApiOperationResponseFunction} from '../base/apiConnectionInfrastructure';
import {ILocationInput, ILocationOutput} from '../../model/location';

export const createLocationAPI: ApiOperationResponseFunction<ILocationOutput> = (
    authToken: string,
    payload: {
        location: ILocationInput;
    }
): Observable<IApiSingleResponseBase<ILocationOutput>> => {
    return palipaliAPI.post('api/locations', payload.location, new RestQueryParams(), {
        Authorization: `Bearer ${authToken}`,
    });
};
